import { Client, ClientSubscription } from "@/models/Client";

// Mock client subscriptions with pricing
const clientSubscriptions: ClientSubscription[] = [
  {
    id: "sub1",
    clientId: "c1",
    workoutTypeId: "wt1", // Pilates
    sessionsPerMonth: 8,
    currentCycleSessionsUsed: 0,
    currentCycleStartDate: "2023-05-01",
    startDate: "2023-05-01",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-05-01T00:00:00Z",
    updatedAt: "2023-05-01T00:00:00Z",
    price: 200.00, // Changed from pricePerSession to total price
  },
  {
    id: "sub2",
    clientId: "c1",
    workoutTypeId: "wt2", // HIIT
    sessionsPerMonth: 12,
    currentCycleSessionsUsed: 0,
    currentCycleStartDate: "2023-05-01",
    startDate: "2023-05-01",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-05-01T00:00:00Z",
    updatedAt: "2023-05-01T00:00:00Z",
    price: 240.00, // Changed from pricePerSession to total price
  },
  {
    id: "sub3",
    clientId: "c2",
    workoutTypeId: "wt3", // Yoga
    sessionsPerMonth: 8,
    currentCycleSessionsUsed: 0,
    currentCycleStartDate: "2023-06-01",
    startDate: "2023-06-01",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-06-01T00:00:00Z",
    updatedAt: "2023-06-01T00:00:00Z",
    price: 240.00, // Changed from pricePerSession to total price
  },
  {
    id: "sub4",
    clientId: "c3",
    workoutTypeId: "wt4", // Strength Training
    sessionsPerMonth: 4,
    currentCycleSessionsUsed: 0,
    currentCycleStartDate: "2023-05-15",
    startDate: "2023-05-15",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-05-15T00:00:00Z",
    updatedAt: "2023-05-15T00:00:00Z",
    price: 140.00, // Changed from pricePerSession to total price
  },
];

// Mock clients data
export const clients: Client[] = [
  {
    id: "c1",
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "555-123-4567",
    address: "123 Main St, Anytown, USA",
    registrationDate: "2023-05-01",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-05-01T00:00:00Z",
    updatedAt: "2023-05-01T00:00:00Z",
    subscriptions: [clientSubscriptions[0], clientSubscriptions[1]], // Pilates and HIIT
  },
  {
    id: "c2",
    firstName: "Jane",
    lastName: "Smith",
    email: "jane.smith@example.com",
    phone: "555-987-6543",
    registrationDate: "2023-06-01",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-06-01T00:00:00Z",
    updatedAt: "2023-06-01T00:00:00Z",
    subscriptions: [clientSubscriptions[2]], // Yoga
  },
  {
    id: "c3",
    firstName: "Robert",
    lastName: "Johnson",
    email: "robert.johnson@example.com",
    phone: "555-456-7890",
    address: "456 Oak Ave, Somewhere, USA",
    notes: "Prefers evening sessions",
    registrationDate: "2023-05-15",
    isActive: true,
    organizationId: "org1",
    createdAt: "2023-05-15T00:00:00Z",
    updatedAt: "2023-05-15T00:00:00Z",
    subscriptions: [clientSubscriptions[3], clientSubscriptions[0]], // Strength Training and Pilates
  },
];
